export default __webpack_public_path__ + "static/media/riaz2.2a31e694.2a67eca1.jpg";